import React from 'react'
import { Link } from 'react-router-dom'

function Pristage2() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">Prestige 2</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newprestige2.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Prestige 2</h1>
           <p className="text-xl md:text-2xl font-thin max-w-sm mx-auto text-gray-500">The display that loves your Meat and Charcuterie products.</p>
           <p className="text-xl md:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">The new serve-over range design for small and medium food retail stores. High product display capacity and visibility for meat, charcuterie, and cheese products. The ideal solution to highlight the freshest and the most seductive products of your business.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1  text-center mb-6">
       <p className="text-xl md:text-2xl opacity-90">Meat, Charcuterie and Cheese <span className=' text-blue-400'>-1… +5 °C</span> (3M1)</p>
       <p className="text-xl md:text-2xl opacity-90">Hot Food <span className='text-red-500'>+65 °C</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center md:mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl md:text-2xl text-lime-500 text-center mt-3"> R290</p>
         </div>
    
 {/* case 1 */}
 <div 
               className="flex flex-col  pb-16 md:mt-10  md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Efficient refrigeration and high display capacity for your products</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Ventilated cooling system that guarantees perfect, even temperature distribution throughout the display.
    The large 820 mm deep display surface and 180 mm maximum load height provide high capacity for your products, always in the best possible condition.</div>

</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/priscase.gif" className="max-w-full h-auto object-contain" />
               </div>
             </div>

    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center md:mt-10">
  {[
    {
      img: "images/priscard.jpg",
      text: "Refrigerated under storage that facilitates rapid replenishment of products that are always at hand.",
    },
    {
      img: "images/prescard.gif",
      text: "Sliding service acrylics or curtain (optional) for a more efficient display and greater energy savings.",
    },
    {
      img: "images/prescard1.jpg",
      text: "Lighting highlights the colours and textures of the products without altering the colour of the surroundings.",
    },
    {
      img: "images/prescard2.jpg",
      text: "Front glass with passive anti-condensation system with low energy consumption.",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:mt-10">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Uncomplicated care and hygiene    </p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Details that simplify cleaning tasks and reduce the need for maintenance.</div>
    <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
  Solid and robust construction.
  Stainless steel interior and worktop
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Easy access to the condensing unit via a magnetic lid.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Easy front access to the display tray and interior for sanitizing.
  </li>
 
</ul>
</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/priscase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
          
    
     {/* card & description */}
     <div className="flex flex-wrap gap-6 justify-center mt-12">
  {[
    {
      img: "images/prescard3.jpg",
      text: "Double-glazed end side panels for greater energy efficiency.",
    },
    {
      img: "images/prescard4.jpg",
      text: "Solar thermometer, no batteries, no maintenance, no costs.",
    },
    {
      img: "images/prescard5.jpg",
      text: "Glass shelf with lighting for cross-selling of non-refrigerated products (optional).",
    },
    {
        img: "images/prescard6.gif",
        text: "Built-in multimedia LED displays for a better shopping experience and promotion in store.",
      },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
    
          {/* case 2 */}
          <div 
               className="flex flex-col  pb-16 md:mt-10 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/minicase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Front glass options</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Three front glass options are available: vertical flat glass (VPV), vertical flat glass with free-service (VPV-LS) for self-service products, and curved glass (VC).</div>
</div>
             </div>  
         </div>
     </div>
    
  
        </div>
      )
    }

export default Pristage2